export default "__VITE_ASSET__BwMEp9t1__"